import { useEffect, useState } from "react";
import Permission from "../../../../common/components/auth/Permission";
import { useCostCenterDashboardContext } from "./PurchaseCostCenter.context";

import "./index.scss";
import { IPurchaseCategory } from "../../../../types/purchaseCategory.type";
import { getCategories } from "../../../../common/services/purchaseCategory.api";
import ModalAddCategory from "../modals/ModalAddCategory";
import { IPurchaseCostCenter } from "../../../../types/purchaseCostCenter";
import GenericInput from "../../../../common/components/form/GenericInput";
import { FaTrash } from "react-icons/fa";
import { updateCostCenter } from "../../../../common/services/purchaseCostCenter.api";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";

export function CostCenterDashboard() {
  const { costCenter: costCenterContext, saveCostCenter } = useCostCenterDashboardContext();
  const [costCenter, setCostCenter] = useState(costCenterContext);
  const [categories, setCategories] = useState<IPurchaseCategory[]>([]);
  const { notifyError, notifySuccess } = useToastContext();

  const EMPTY_ACTION = { eventName: '', data: undefined };
  const [action, setAction] = useState<{ eventName: string, data?: IPurchaseCostCenter }>(EMPTY_ACTION);
  const isAction = (eventName: string) => action.eventName === eventName;

  useEffect(() => {
    setCostCenter(costCenterContext);
  }, [costCenterContext]);

  if (!costCenterContext) {
    return <div>Loading...</div>;
  }

  const cleanActionData = () => {
    setAction({ eventName: '', data: undefined })
  }

  const onSave = (data: IPurchaseCostCenter) => {
    setAction({ eventName: 'created', data: data })
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    async function loadCategories() {
      const result = await getCategories();
      const categoriesFilter = result.data.filter(category => costCenter.categoriesId.includes(category._id));
      setCategories(categoriesFilter);
    }
    loadCategories();
  }, [costCenter.categoriesId]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (action.data) {
      setCostCenter(action.data);
    }
  }, [action])

  const deleteCategory = async (id: string) => {

    const categoriesId = costCenter.categoriesId.filter(el => el != id);
    costCenter.categoriesId = categoriesId;
    const result = await updateCostCenter(costCenter);
    if (result.ok) {
      notifySuccess("Deletado Categoria")
    }
    if (!result.ok && result.message) {
      notifyError(result.message);
    }
    setAction({ eventName: 'delete', data: { ...costCenter } })
  }

  return (
    <div className="relative w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="w-full">
        <div className="col-span-2">
          <h2 className="text-2xl mt-5 ml-4 font-semibold mb-4 titleCostCenter">Centro de Custo: {costCenter.description}</h2>
          <Permission permission="edit:inventory-pieces">
            {costCenter._id &&
              <div className="containerCardsCostCenter">
                <section className="bg-gray/40 p-4 dark:text-black rounded-md">
                  <>
                    <div className="containerButtonCostOrder">
                      <button onClick={() => setAction({ eventName: 'add' })} className="bg-redPrimary hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                        Adicionar Categoria
                      </button>
                    </div>
                    <h2 className="text-2xl font-semibold mb-4">Categorias:</h2>

                    {categories.map(category => {
                      return (
                        <div key={category._id} className="containerInputs">
                          <GenericInput label={""} mask={undefined} value={category.name}></GenericInput>
                          <FaTrash onClick={() => deleteCategory(category._id)}></FaTrash>
                        </div>
                      )
                    })}
                  </>
                </section>
              </div>
            }
          </Permission>
        </div>
      </section>
      {isAction('add') && <ModalAddCategory onSave={onSave} costCenter={costCenter} saveCostCenter={saveCostCenter} onClose={cleanActionData}></ModalAddCategory>}
    </div>
  )
}